export const CHECKOUT_SESSION_STATUS = {
  complete: 'complete',
  expired: 'expired',
  open: 'open',
};
